import { api, requestHeaders } from '../../../functions/api';
import {
    IResetPasswordResponse,
    ResetPasswordResponseEnum,
} from '../components/models/ResetPassword.models';

export class ResetPasswordService {
    private headers = { ...requestHeaders };

    /**
     * Solicita el reseteo de la contraseña del usuario por username o email.
     * Devuelve un objeto indicando el resultado para que el controlador del front notifique el feedback correcto vía notificación y se cierre en caso de ok.
     */
    public async resetPasswordForUser(
        userNameOrEmailEnteredByUser: string
    ): Promise<IResetPasswordResponse> {
        const encodedUserNameOrEmail = encodeURIComponent(userNameOrEmailEnteredByUser);
        const endpoint = `${api}users/userresetpassword?usernameOrEmail=${encodedUserNameOrEmail}`;

        try {
            const response = await fetch(endpoint, {
                method: 'GET',
                headers: this.headers,
                credentials: 'include',
            });

            if (response.status === 204) {
                // Respuesta ok
                return { status: ResetPasswordResponseEnum.SUCCESS };
            } else if (response.status === 404) {
                // Usuario no encontrado
                return { status: ResetPasswordResponseEnum.NOT_FOUND };
            } else {
                // Otro error
                const errorCode = response.status?.toString() || 'unknown';
                return { status: ResetPasswordResponseEnum.ERROR, errorCode };
            }
        } catch (error) {
            // Errores de red o similar
            return { status: ResetPasswordResponseEnum.ERROR, errorCode: 'network' };
        }
    }
}
